import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import store from '@store';
import type { RootState } from '@store/reducers';

type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
